module.exports = __webpack_public_path__ + "img/course-slider-2.342fd0f3.png";